import { render, staticRenderFns } from "./RightSidebar.vue?vue&type=template&id=193e9580"
import script from "./RightSidebar.vue?vue&type=script&lang=ts"
export * from "./RightSidebar.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports